import { Box } from '@mui/material';
import type { BoxProps } from '@mui/material';

import ErrorCircle from '@experimental-components/IconsComponents/Alert';
import WarningTriangle from '@experimental-components/IconsComponents/WarningTriangle';
import Information from '@experimental-components/IconsComponents/Indicators/Information';

import useStyles from './styles';

const typeIcon = {
  warning: WarningTriangle,
  error: ErrorCircle,
  info: Information,
};

interface Props extends BoxProps {
  severity: 'warning' | 'error' | 'info';
  sizeIcon?: number;
  children: React.ReactNode;
  customIcon?: React.ReactNode;
  showAlert?: boolean;
}

export const AlertMessage = ({
  severity = 'warning',
  sizeIcon = 24,
  children,
  customIcon,
  showAlert = true,
  ...others
}: Props) => {
  const classes = useStyles({ severity });

  const IconAlert = typeIcon[severity];

  const renderIcon = () => {
    if (customIcon) return customIcon;

    return (
      <Box alignItems="center" display="flex">
        <IconAlert colorInherit="#FFF" size={sizeIcon} />
      </Box>
    );
  };

  return showAlert ? (
    <Box className={classes.root} {...others}>
      {renderIcon()}

      <Box>{children}</Box>
    </Box>
  ) : null;
};

export default AlertMessage;
